// useMintInfo.js
import { useState, useEffect } from 'react';
import api from '../utils/axios';

const useMintInfo = () => {
	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchMintInfo = async () => {
			setLoading(true);
			try {
				const response = await api.get('/mint-info');
				setData(response.data);
			} catch (error) {
				console.error('Error fetching mint info:', error);
			} finally {
				setLoading(false);
			}
		};

		fetchMintInfo();
	}, []);

	return { data, loading };
};

export default useMintInfo;
